function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import MuiRadio from '@material-ui/core/Radio';
import FormControlGroup from '../FormControlGroup';
import RadioGroup from '../RadioGroup';
import FormControlOptionLabel from '../FormControlOptionLabel';
export var FormControlRadioGroup = /*#__PURE__*/memo(function (props) {
  var options = props.options,
      groupProps = _objectWithoutProperties(props, ["options"]);

  return /*#__PURE__*/React.createElement(FormControlGroup, Object.assign({
    component: RadioGroup
  }, omit(groupProps, 'renderFormControl')), options.map(function (_ref) {
    var label = _ref.label,
        labelPlacement = _ref.labelPlacement,
        controlProps = _objectWithoutProperties(_ref, ["label", "labelPlacement"]);

    return /*#__PURE__*/React.createElement(FormControlOptionLabel, {
      key: controlProps.value,
      control: /*#__PURE__*/React.createElement(MuiRadio, Object.assign({
        color: "primary"
      }, controlProps)),
      label: label,
      labelPlacement: labelPlacement
    });
  }));
});
export var propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    label: PropTypes.string,
    labelPlacement: PropTypes.string,
    value: PropTypes.string
  })),
  value: PropTypes.string
};
FormControlRadioGroup.propTypes = propTypes;
export default FormControlRadioGroup;